import script from "./LayoutTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutTopbar.vue?vue&type=script&setup=true&lang=js"

import "./LayoutTopbar.vue?vue&type=style&index=0&id=640c06b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640c06b0"]])

export default __exports__